import type { Employee } from '../types';

/** When task has a location, only count employees whose profile includes that location */
export function employeeMatchesTaskLocation(
  emp: Employee,
  taskLocationId: number | null | undefined
): boolean {
  if (taskLocationId == null || taskLocationId === undefined) return true;
  const main = emp.profile?.mainLocationId;
  const subs = emp.profile?.subLocationIds ?? [];
  return main === taskLocationId || subs.includes(taskLocationId);
}

export function filterEmployeesByPositionAssignment(
  all: Employee[],
  positionId: number,
  taskLocationId?: number | null
): Employee[] {
  return all
    .filter((e) => {
      if (!e.isActive) return false;
      if (!employeeMatchesTaskLocation(e, taskLocationId)) return false;
      const main = e.profile?.mainPositionId;
      const subs = e.profile?.subPositionIds ?? [];
      return main === positionId || subs.includes(positionId);
    })
    .sort((a, b) =>
      `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`, undefined, {
        sensitivity: 'base',
      })
    );
}

export function filterEmployeesByScheduleAssignment(
  all: Employee[],
  scheduleId: number,
  taskLocationId?: number | null
): Employee[] {
  return all
    .filter((e) => {
      if (!e.isActive) return false;
      if (!employeeMatchesTaskLocation(e, taskLocationId)) return false;
      const ids = e.profile?.scheduleIds ?? [];
      return ids.includes(scheduleId);
    })
    .sort((a, b) =>
      `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`, undefined, {
        sensitivity: 'base',
      })
    );
}
